import { render, staticRenderFns } from "./AddContestModal.vue?vue&type=template&id=6b6e1e09"
import script from "./AddContestModal.vue?vue&type=script&lang=ts"
export * from "./AddContestModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports